import { useCallback, useMemo, useState } from 'react'
import SummaryDashboard from '../components/snoop/SummaryDashboard'
import { fetchPgpRoster } from '../api/pgpClient'
import { PLACEHOLDER_PGP_ROSTER } from '../utils/snoop/placeholderColumns'

const CREDIT_TYPE_OPTIONS = [
  { value: '', label: 'Writers + producers' },
  { value: 'writer', label: 'Writers' },
  { value: 'producer', label: 'Producers' },
]

const selectClass =
  'rounded-lg border border-gray-300 bg-white px-2.5 py-1.5 text-sm text-gray-800 shadow-sm focus:border-gray-400 focus:outline-none'

export default function PgpRosterPage() {
  const [creditType, setCreditType] = useState('')

  const fetchData = useCallback(
    () => fetchPgpRoster({ creditType: creditType || undefined }),
    [creditType],
  )

  const defaultSort = useMemo(
    () => [
      { column: 'Release Date', direction: 'desc' },
      { column: 'Song', direction: 'asc' },
      { column: 'Name', direction: 'asc' },
    ],
    [],
  )

  // Song ID / Artist ID stay visible: they render as Genius links.
  const hiddenColumns = useMemo(
    () => ['Pub Mapping ID', 'Genius URL', 'First Seen', 'Lead A&R'],
    [],
  )

  const headerLabels = useMemo(
    () => ({
      'Genius Song ID': 'Song ID',
      'Genius Artist ID': 'Artist ID',
    }),
    [],
  )

  const extraActions = (
    <label className="inline-flex items-center gap-2 text-sm text-gray-600">
      Credit
      <select
        className={selectClass}
        value={creditType}
        onChange={(e) => setCreditType(e.target.value)}
      >
        {CREDIT_TYPE_OPTIONS.map((opt) => (
          <option key={opt.value || 'all'} value={opt.value}>
            {opt.label}
          </option>
        ))}
      </select>
    </label>
  )

  return (
    <SummaryDashboard
      title="Roster"
      subtitle="Roster writers/producers on Genius releases from the last 14 days (refreshed weekly)"
      fetchData={fetchData}
      defaultSort={defaultSort}
      searchPlaceholder="Search writer, song, or primary artist…"
      extraActions={extraActions}
      layout="mapping"
      truncateColumns={['Song', 'Primary Artist', 'Name']}
      hiddenColumns={hiddenColumns}
      headerLabels={headerLabels}
      placeholderColumns={PLACEHOLDER_PGP_ROSTER}
      tableKey={`pgp-roster-${creditType || 'all'}`}
    />
  )
}
